import React from 'react';

const ImpactStatement = () => {
  return (
    <section className="py-24 px-6 bg-gradient-to-b from-black to-zinc-900">
      <div className="max-w-5xl mx-auto text-center">
        {/* Heading - Smaller */}
        <h2 className="heading-font text-2xl md:text-3xl font-bold text-white mb-12">
          What do we exactly give you?
        </h2>
        
        {/* Two paragraphs */}
        <div className="space-y-6 body-font text-lg text-gray-300 leading-relaxed max-w-4xl mx-auto mb-16">
          <p>
            Whether it's an intimate gathering or a large-scale production, every experience is built around one core idea—<br/>
            <span className="text-white font-semibold">how it should feel.</span>
          </p>
          
          <p>
            We curate premium evenings for families, friends, and professional groups, where every element is thoughtfully designed—<br/>
            from music and ambience to food, décor, and overall flow.
          </p>
        </div>

        {/* Gold one-liner */}
        <div className="mb-12">
          <p className="heading-font text-3xl md:text-4xl font-bold gold-accent leading-relaxed">
            Make it worth remembering. We don't just set up evenings—we design how they feel.
          </p>
        </div>
        
        {/* Quoted italic line */}
        <p className="body-font text-lg text-gray-300 italic leading-relaxed max-w-3xl mx-auto mb-16">
          "From the first arrival to the last conversation of the night, everything is curated, controlled, and elevated."
        </p>
        
        {/* Warning Box */}
        <div className="mt-12 p-8 bg-zinc-800 rounded-sm border-2 border-yellow-600">
          <p className="heading-font text-xl md:text-2xl text-white font-bold mb-2">
            Warning:
          </p>
          <p className="body-font text-lg gold-accent italic">
            Your guests may not want to leave.
          </p>
        </div>
      </div>
    </section>
  );
};

export default ImpactStatement;
